import React from "react";
import { BaseChunk } from "./ChunkMethodsBase";
import { SaveStatus } from "./SaveStatus";

export class PlainChunk extends BaseChunk {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.myInputRef = React.createRef();
  }

  // propTypes defined in base
  // getDefaultProps defined in base
  getInitialState() {
    // this.props.model.on("change:saveStatus change:order_index", () => {
    //   if (this.isMounted()) {
    //     return this.forceUpdate();
    //   }
    // })e
    const value = this.props.model[this.props.field];
    const label = this.props?.label ?? value;
    return {
      label: label,
      placeholder: `Enter a ${label}...`,
      rawContent: value,
      content: this.inputToMarkdown(value),
      isEditing: false,
      model: this.props.model,
    };
  }

  isEditing() {
    return this.state.isEditing;
  }

  render() {
    var divClasses;
    divClasses = "chunk edit plain" + (this.state.isEditing ? " active" : "");
    return (
      <div
        ref={this.containerRef}
        className={divClasses}
        onKeyDown={this.onKeyDown.bind(this)}
        onKeyUp={this.onKeyUp.bind(this)}
        data-id={this.props.model.id}
      >
        <div className="block">
          <h1>{this.state.label}:</h1>
          {this.state.isEditing ? (
            <div
              key="editing"
              className="chunk-edit"
              onFocus={this.onFocus.bind(this)}
              onBlur={this.onEditEnd.bind(this)}
            >
              <textarea
                ref={this.myInputRef}
                placeholder={this.state.placeholder}
                value={this.state.rawContent}
                onChange={this.updateContent.bind(this)}
              />
            </div>
          ) : (
            <div
              key="not_editing"
              className="chunk-display"
              onFocus={this.startEdit.bind(this)}
              onClick={this.startEdit.bind(this)}
              contentEditable="true"
              data-placeholder={this.state.placeholder}
              dangerouslySetInnerHTML={{ __html: this.state.content }}
            ></div>
          )}
          <p className="markdown-help">{this.props.help}</p>
        </div>
        <SaveStatus status={undefined} />
      </div>
    );
  }
}
